module.exports = __webpack_public_path__ + "static/media/recharge-mobile.35b90ee2.jpeg";